import { render, staticRenderFns } from "./ZammadTicketImgPlaceholder.vue?vue&type=template&id=30b774ab"
import script from "./ZammadTicketImgPlaceholder.vue?vue&type=script&lang=ts"
export * from "./ZammadTicketImgPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports